import { useContext } from 'react';
import { SettingsContext } from 'src/App/context/settings-context';

export const useSettings = () => useContext(SettingsContext);
